/* eslint react/prop-types:0 */
import React from 'react';

import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadablePaint } from '@confluence/loadable';

const SpaceSettingsExportSpaceUnavailableRouteComponent = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-SpaceSettingsExportSpaceUnavailableRouteComponent" */ './SpaceSettingsExportSpaceUnavailableRouteComponent.tsx'
		),
});

export const SpaceSettingsExportSpaceUnavailableRoute = ({ params: { spaceKey } }) => (
	<SpaceSettingsExportSpaceUnavailableRouteComponent spaceKey={spaceKey} />
);

SpaceSettingsExportSpaceUnavailableRoute.NAVIGATION_PARAMS = (
	{ name, params: { spaceKey } },
	isNav4Enabled,
) => ({
	Screen: {
		screenEvent: { name: 'spaceSettingsExportSpaceUnavailable', id: spaceKey },
		pageState: { spaceKey, routeName: name },
	},
	MainLayout: {
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		spaceKey,
		disableMinWidth: true,
	},
});
